export default {
  modelName: 'Dodone',
  attributes: {
    ancestry: {
      name: "ancestry",
      apiName: "ancestry",
      camelName: "ancestry",
      underscoreName: "ancestry",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Ancestry",
    },
    comment: {
      name: "comment",
      apiName: "comment",
      camelName: "comment",
      underscoreName: "comment",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Comment",
    },
    createdAt: {
      name: "createdAt",
      apiName: "createdAt",
      camelName: "createdAt",
      underscoreName: "created_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Created At",
    },
    currentAt: {
      name: "currentAt",
      apiName: "currentAt",
      camelName: "currentAt",
      underscoreName: "current_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Current At",
    },
    day: {
      name: "day",
      apiName: "day",
      camelName: "day",
      underscoreName: "day",
      type: "date",
      writeable: true,
      default: null,
      humanName: "Day",
    },
    dodoable: {
      name: "dodoable",
      apiName: "dodoable",
      camelName: "dodoable",
      underscoreName: "dodoable",
      type: "belongs_to",
      writeable: true,
      default: null,
      humanName: "Dodoable",
      model: "Dodoable",
    },
    dodoableId: {
      name: "dodoableId",
      apiName: "dodoableId",
      camelName: "dodoableId",
      underscoreName: "dodoable_id",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "Dodoable",
    },
    finishedAt: {
      name: "finishedAt",
      apiName: "finishedAt",
      camelName: "finishedAt",
      underscoreName: "finished_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Finished At",
    },
    googleDriveProofFileId: {
      name: "googleDriveProofFileId",
      apiName: "googleDriveProofFileId",
      camelName: "googleDriveProofFileId",
      underscoreName: "google_drive_proof_file_id",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Google Drive Proof File",
    },
    googleDriveProofFileName: {
      name: "googleDriveProofFileName",
      apiName: "googleDriveProofFileName",
      camelName: "googleDriveProofFileName",
      underscoreName: "google_drive_proof_file_name",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Google Drive Proof File Name",
    },
    googleDriveProofWebLinkView: {
      name: "googleDriveProofWebLinkView",
      apiName: "googleDriveProofWebLinkView",
      camelName: "googleDriveProofWebLinkView",
      underscoreName: "google_drive_proof_web_link_view",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Google Drive Proof Web Link View",
    },
    id: {
      name: "id",
      apiName: "id",
      camelName: "id",
      underscoreName: "id",
      type: "integer",
      writeable: false,
      default: null,
      humanName: "Id",
    },
    isClosed: {
      name: "isClosed",
      apiName: "closed?",
      camelName: "isClosed",
      underscoreName: "is_closed",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Closed",
    },
    isFinished: {
      name: "isFinished",
      apiName: "finished?",
      camelName: "isFinished",
      underscoreName: "is_finished",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Finished",
    },
    isIgnorable: {
      name: "isIgnorable",
      apiName: "ignorable?",
      camelName: "isIgnorable",
      underscoreName: "is_ignorable",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Ignorable",
    },
    isNotFinished: {
      name: "isNotFinished",
      apiName: "notFinished?",
      camelName: "isNotFinished",
      underscoreName: "is_not_finished",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Not Finished",
    },
    isNotStarted: {
      name: "isNotStarted",
      apiName: "notStarted?",
      camelName: "isNotStarted",
      underscoreName: "is_not_started",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Not Started",
    },
    isOpen: {
      name: "isOpen",
      apiName: "open?",
      camelName: "isOpen",
      underscoreName: "is_open",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Open",
    },
    isPrevious: {
      name: "isPrevious",
      apiName: "previous?",
      camelName: "isPrevious",
      underscoreName: "is_previous",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Previous",
    },
    isProvable: {
      name: "isProvable",
      apiName: "provable?",
      camelName: "isProvable",
      underscoreName: "is_provable",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Provable",
    },
    isStarted: {
      name: "isStarted",
      apiName: "started?",
      camelName: "isStarted",
      underscoreName: "is_started",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Started",
    },
    listItemText: {
      name: "listItemText",
      apiName: "listItemText",
      camelName: "listItemText",
      underscoreName: "list_item_text",
      type: "string",
      writeable: true,
      default: null,
      humanName: "List Item Text",
    },
    log: {
      name: "log",
      apiName: "log",
      camelName: "log",
      underscoreName: "log",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Log",
    },
    name: {
      name: "name",
      apiName: "name",
      camelName: "name",
      underscoreName: "name",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Name",
    },
    order: {
      name: "order",
      apiName: "order",
      camelName: "order",
      underscoreName: "order",
      type: "integer",
      writeable: true,
      default: 0,
      humanName: "Order",
    },
    proofStatus: {
      name: "proofStatus",
      apiName: "proofStatus",
      camelName: "proofStatus",
      underscoreName: "proof_status",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Proof Status",
    },
    settings: {
      name: "settings",
      apiName: "settings",
      camelName: "settings",
      underscoreName: "settings",
      type: "jsonb",
      writeable: true,
      default: "{}",
      humanName: "Settings",
    },
    startedAt: {
      name: "startedAt",
      apiName: "startedAt",
      camelName: "startedAt",
      underscoreName: "started_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Started At",
    },
    status: {
      name: "status",
      apiName: "status",
      camelName: "status",
      underscoreName: "status",
      type: "string",
      writeable: true,
      default: "pending",
      humanName: "Status",
    },
    timeout: {
      name: "timeout",
      apiName: "timeout",
      camelName: "timeout",
      underscoreName: "timeout",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "Timeout",
    },
    type: {
      name: "type",
      apiName: "type",
      camelName: "type",
      underscoreName: "type",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Type",
    },
    updatedAt: {
      name: "updatedAt",
      apiName: "updatedAt",
      camelName: "updatedAt",
      underscoreName: "updated_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Updated At",
    },
    user: {
      name: "user",
      apiName: "user",
      camelName: "user",
      underscoreName: "user",
      type: "belongs_to",
      writeable: true,
      default: null,
      humanName: "User",
      model: "User",
    },
    userId: {
      name: "userId",
      apiName: "userId",
      camelName: "userId",
      underscoreName: "user_id",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "User",
    },
  },
  names: {
    model: "Dodone",
    base: "dodone",
    baseSingularClass: "Dodone",
    human: "Dodone",
    singularCamelFull: "dodone",
    singularCamel: "dodone",
    singularClassFull: "Dodone",
    singularClass: "Dodone",
    singularDash: "dodone",
    singularUnderscoreFull: "dodone",
    singularUnderscore: "dodone",
    singularUnderscorePath: "dodone",
    pluralModel: "Dodones",
    pluralCamelFull: "dodones",
    pluralCamel: "dodones",
    pluralClass: "Dodones",
    pluralDash: "dodones",
    pluralUnderscoreFull: "dodones",
    pluralUnderscore: "dodones",
    pluralUnderscorePath: "dodones",
  },
  validators: [
    {
      className: "ActiveModel::Validations::FormatValidator",
      options: {
        allowNil: true,
        with: null,
      },
      attributes: [
        "ancestry",
      ],
    },
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "user",
      ],
    },
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "dodoable",
      ],
    },
  ],
  enums: {
    status: {
      name: "status",
      valueMap: {
        pending: 0,
        ongoing: 1,
        completed: 2,
        ignored: 3,
      },
      options: {
        pending: 0,
        ongoing: 1,
        completed: 2,
        ignored: 3,
      },
      settings: {
      },
    },
    proofStatus: {
      name: "proofStatus",
      valueMap: {
        ignored: 0,
        pending: 1,
        saving: 2,
        completed: 3,
      },
      options: {
        ignored: 0,
        pending: 1,
        saving: 2,
        completed: 3,
      },
      settings: {
        prefix: true,
      },
    },
  },
}
